import { IChecklistTask } from '@features/Checklist/model/types';

export const normalizeChecklistSortOrder = (items: IChecklistTask[]) =>
    items.map((item, index) => ({
        ...item,
        sortOrder: index + 1,
    }));
